import { gql } from 'graphql-tag';

import { fullSizedImageFragment } from './image.fragments';

export const fullSizedImageQuery = gql`
  query image ($id: ID!) {
    image (id: $id) {
      ...FullSizedImageData
    }
  }

  ${fullSizedImageFragment}
`;
